module.exports = __webpack_public_path__ + "img/multiply.46f0b8e2.svg";